import React, { useState, useEffect } from "react";
// Importing DelDatePicker
import { SamplingEventDatePicker } from "../../../../common/DelDatePicker";
import styles from "../DailySummaryTab.module.css"; // Assuming shared styles or create a new one

export const AddDailySummaryModal = ({
  isOpen,
  onClose,
  onSubmit,
  existingDates, // Array of date strings (e.g., "YYYY-MM-DD")
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [error, setError] = useState("");

  // Reset state when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setSelectedDate("");
      setError("");
    }
  }, [isOpen]);

  const handleDateChange = (e) => {
    console.log("e", e);
    setSelectedDate(e);
    if (error) {
      setError(""); // Clear error when date changes
    }
  };

  const handleSubmit = () => {
    if (!selectedDate) {
      setError("Please select a date.");
      return;
    }
    // Dates from input type="date" are YYYY-MM-DD
    if (existingDates.includes(selectedDate)) {
      setError(
        "A summary for this date already exists. Please choose a different date."
      );
      return;
    }
    onSubmit(selectedDate); // Pass the YYYY-MM-DD string
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Add New Daily Summary</h3>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <label htmlFor="dailySummaryDate">Select Date:</label>
          <SamplingEventDatePicker
            id="dailySummaryDate"
            selected={selectedDate}
            onChange={handleDateChange}
            className={styles.datePickerInput} // Add specific styling if needed
          />
          {error && <p className={styles.errorMessage}>{error}</p>}
        </div>
        <div className={styles.modalActions}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.confirmButton} onClick={handleSubmit}>
            Add Summary
          </button>
        </div>
      </div>
    </div>
  );
};
